
import Vue from 'vue';

import { faChevronDown } from '@delfi.lt/fa-kit/icons/modules/classic/solid';

interface Methods {
  closePaywall: () => void;
}

interface Computed {
  customerToken: string | null;
  hasChannelAccess: boolean;
}

interface PodcastPaywallWindow {
  tp: any;
}

declare const window: PodcastPaywallWindow;

export default Vue.extend<unknown, Methods, Computed, unknown>({
  data() {
    return {
      faChevronDown,
    };
  },
  computed: {
    customerToken() {
      return this.$store.state.piano.token;
    },
    hasChannelAccess() {
      return this.$store.state.piano.access.channelAccess;
    },
  },
  watch: {
    hasChannelAccess() {
      if (this.hasChannelAccess) {
        this.closePaywall();
        this.$nuxt.$emit('podcast-paywall-close');
      }
    },
  },
  methods: {
    closePaywall() {
      this.$store.dispatch('podcast/setShowPaywall', false);
    },
  },
  mounted() {
    this.$store.dispatch('piano/showOfferByType', {
      containerSelector: '.paywall__content',
      type: 'paywall',
    });

    window.tp.push(['addHandler', 'loginSuccess', () => {}]);
    window.tp.push(['addHandler', 'checkoutCompleted', () => {}]);
  },
});
